import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Angle extends OBase {
  update () {
    let aValTree = this.getVector3Input('Vector A', false);
    let bValTree = this.getVector3Input('Vector B', false);
    let pValTree = this.getPlaneInput('Plane', false);

    let aOutput = this.getGenericObjectOutput('Angle');
    let rOutput = this.getGenericObjectOutput('Reflex');

    let dataTrees = [];
    let outDataTrees = [];
    dataTrees.push(aValTree, bValTree, pValTree);

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let aOutTree = new Geometry.DataTree();
    let rOutTree = new Geometry.DataTree();
    for (let i = 0; i < outDataTrees[0].branches.length; i++) {
      for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
        let aVal = outDataTrees[0].branches[i][j];
        let bVal = outDataTrees[1].branches[i][j];
        let plane = outDataTrees[2].branches[i][j];

        let angVal;
        if (plane !== null && plane !== undefined) {
          let projA = aVal.clone().projectOnPlane(plane.normal);
          let projB = bVal.clone().projectOnPlane(plane.normal);

          let pa2 = new THREE.Vector2(plane.xAxis.dot(projA), plane.yAxis.dot(projA));
          let pb2 = new THREE.Vector2(plane.xAxis.dot(projB), plane.yAxis.dot(projB));

          angVal = pb2.angle() - pa2.angle();
        } else {
          angVal = aVal.angleTo(bVal);
        }

        let refVal = Math.PI * 2.0 - angVal;

        aOutTree.add(angVal, outDataTrees[0].paths[i]);
        rOutTree.add(refVal, outDataTrees[0].paths[i]);
      }
    }

    aOutput.value = aOutTree;
    rOutput.value = rOutTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Angle.js